import React from 'react'
import styled from 'styled-components'
import { theme } from 'infra/theme'
import { Logo } from 'components/common/logo'
import { FiChevronRight } from 'react-icons/fi'
import { Column, ResponsiveLayout, Row } from 'components/common/layout'
import { BaseText, BoldText } from 'components/common/text'
import { textEllipsis } from 'components/common/styles'
import { useIsDesktop } from 'utils/hooks'
import { MyLink } from 'components/common/link'

export const StartupSimpleBanner: React.FC<{
  startup: {
    id: number
    thumbnail: string | null
    name: string
    briefIntro: string
    location: string
    serviceAreas: string[]
  }
  width: number
}> = ({ startup, width }) => {
  const isDesktop = useIsDesktop()
  return (
    <MyLink href={`/startups/${startup.id}`} newTab>
      <Container>
        <Wrapper width={width}>
          <Row style={{ gap: 16, overflow: 'hidden' }}>
            <Logo
              src={startup.thumbnail}
              placeholder={startup.name}
              size={isDesktop ? 70 : 60}
            />
            <Column style={{ gap: 6, overflow: 'hidden' }}>
              <Column style={{ gap: 4 }}>
                <MainText>{startup.name}</MainText>
                <DescText>{startup.briefIntro}</DescText>
              </Column>
              <SubText>
                {startup.location} ‧ {startup.serviceAreas.join(' ‧ ')}
              </SubText>
            </Column>
          </Row>
          <Row style={{ flex: 'none' }}>
            <FiChevronRight size={24} color={theme.color.gray1} />
          </Row>
        </Wrapper>
      </Container>
    </MyLink>
  )
}

const Container = styled(Row)`
  border-bottom: 1px solid ${(p) => p.theme.color.line};
  cursor: pointer;
`

const Wrapper = styled(ResponsiveLayout)<{ width?: number }>`
  display: flex;
  padding: 20px 0;
  overflow: hidden;
  align-items: center;
  justify-content: space-between;
  ${(p) =>
    p.width &&
    `
  width: ${p.width}px;
  `}
  @media ${(p) => p.theme.deviceSize.mobile} {
    padding: 16px;
  }
`

const MainText = styled(BoldText)`
  font-size: ${(p) => p.theme.fontSize.h5};
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.desc};
  }
`
const DescText = styled(BaseText)`
  ${textEllipsis}
`

const SubText = styled(BaseText)`
  font-size: 14px;
  color: ${(p) => p.theme.color.gray1};
  @media ${(p) => p.theme.deviceSize.mobile} {
    font-size: ${(p) => p.theme.fontSize.small};
  }
`
